import React from 'react';
import './Pages.css';

function LaminateDetail({ item, onBack }) {
  if (!item) {
    return (
      <div className="page laminate-detail-page">
        <div className="page-container">
          <p>Item not found</p>
          <button className="back-btn" onClick={onBack}>← Back to Laminates</button>
        </div>
      </div>
    );
  }

  const designCode = item.name.split(' ')[0];
  const finishType = item.name.split(' ')[1] || '';

  // Finish type descriptions
  const finishDescriptions = {
    'ZR': 'Zero Reflection',
    'CO': 'Classic Oak',
    'RX': 'Relaxed Texture',
    'SF': 'Soft Finish',
    'UHG': 'Ultra High Gloss',
    'HZ': 'Horizon'
  };

  return (
    <div className="page laminate-detail-page">
      <div className="detail-container">
        <button className="back-btn" onClick={onBack}>
          <span className="back-arrow">←</span> Back to Laminates
        </button>
        
        <div className="detail-layout fade-in">
          <div className="detail-thumbnail">
            <img src="/crunch.png" alt={`${item.name} - Crunch`} />
          </div>
          
          <div className="detail-main-image">
            <img src="/crunch.png" alt={`${item.name} - Crunch`} />
          </div>
          
          <div className="detail-info">
            <span className="detail-badge">Premium Laminate</span>
            <h2>{item.name}</h2>
            <div className="detail-meta">
              <div className="meta-item">
                <span className="meta-label">Design Code</span>
                <span className="meta-value">{designCode}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Finish Type</span>
                <span className="meta-value">{finishType}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Finish Name</span>
                <span className="meta-value">{finishDescriptions[finishType] || finishType}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Thickness</span>
                <span className="meta-value">0.8mm</span>
              </div>
            </div>
            <button className="inquiry-btn" onClick={() => window.location.hash = 'contact'}>
              Inquire Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LaminateDetail;
